import React from "react";
import apiProxy from "../../api/apiProxy";
import StoreZoneConfigurePage from "./StoreZoneConfigurePage.js";

export default props => (
  <StoreZoneConfigurePage
    storeId={props.match.params.storeId}
    zoneId={props.match.params.zoneId}
    getZones={apiProxy.zone.getZones}
    getStore={apiProxy.storeLighting.getStore}
    getStoreZoneConfiguration={apiProxy.storeLighting.getStoreZoneConfiguration}
  />
);
